<template>
    <v-card id="create">
        <v-container fluid>
            <v-form ref="form" lazy-validation>
                <v-card-title>新增簡訊
                    <v-spacer></v-spacer>
                    <v-btn color="success" class="mr-2" @click="onFindClick">查詢已發送簡訊資料</v-btn>
                    <v-btn color="primary" class="mr-2" @click="onSendClick">發送簡訊</v-btn>
                    <v-dialog v-model="sendDialog" max-width="700px" persistent>
                        <v-card>
                            <v-card-title>簡訊發送確認</v-card-title>
                            <v-card-subtitle>請確認您發送的簡訊內容及發送對象是否正確？</v-card-subtitle>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col>
                                    <v-card-subtitle><b>簡訊內容</b></v-card-subtitle>
                                    <v-card-text v-html="DisplayedMessage"></v-card-text>
                                </v-col>
                                <v-col>
                                    <v-card-subtitle><b>發送對象{{ (holder_selected_list.length > 0) ? "：共" + holder_selected_list.length + "筆" : "" }}</b></v-card-subtitle>
                                    <v-list style="max-height: 400px" class="overflow-y-auto">
                                         <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>客戶姓名/電話</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-content>
                                                <v-list-item-title>業務員/等級</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <div v-for="(field, index) in holder_selected_list" :key="index">
                                            <v-list-item two-line>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{field.name}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{field.phone}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{field.salesman}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{field.level}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                    </v-list>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" :disabled="disableCloseSendButton" @click="closeSendDialog">不，我要修改內容</v-btn>
                                <v-btn color="success" @click="confirmSendMessage" width="120px">
                                    <div v-show="!sendMessageLoading">是，確認發送</div>
                                    <div v-show="sendMessageLoading">
                                        <v-progress-circular size="25" indeterminate></v-progress-circular>
                                    </div>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="sentMessageResultDialog"  max-width="700px" persistent>
                        <v-card>
                            <v-card-title>簡訊傳送完成</v-card-title>
                            <v-card-text>{{this.message}}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="confirmSentResult">確定</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-title>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-card-title>選擇欲傳送的客戶</v-card-title>
                            <v-card-subtitle v-show="isNotSelectHolder"><font color="#ff0000">請選擇欲發送簡訊的客戶</font></v-card-subtitle>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="3">
                                        <salesman-combo
                                            v-model="salesman"
                                            label="業務員姓名">
                                        </salesman-combo>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model="holderName" label="請輸入客戶姓名"></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-select
                                            v-model="level"
                                            :items="level_items"
                                            label="客戶等級"
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="2">
                                        <v-btn @click="onSearchClick">查詢</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-divider></v-divider>
                            <v-data-table
                                :headers="listHolders"
                                :items="holder_list"
                                :hide-default-footer="true"
                                disable-pagination
                                :fixed-header="true"
                                height="450px"
                            >
                                <template v-slot:[`header.actions`]>
                                    <v-btn @click="addAllItemToSelectList">全選</v-btn>
                                </template>
                                <template v-slot:[`item.actions`]="{item}">
                                    <v-btn  v-show="item.isCellPhone" :disabled="item.selected == true" @click="addItemToSelectList(item.id)">選擇</v-btn>
                                </template>
                            </v-data-table>
                            
                        </v-card>
                    </v-col>
                    <v-col>
                        <v-row>
                            <v-col>
                                <v-card>
                                    <v-card-title>簡訊發送內容</v-card-title>
                                    <v-card-text>
                                        <v-textarea
                                            v-model="requestItem.message"
                                            counter = 1000
                                            label="請輸入簡訊內容"
                                            required
                                            :rules="[(v) => !!v || '請填寫欲發送之簡訊內容']"
                                        >
                                        </v-textarea>
                                    </v-card-text>
                                </v-card>
                                
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-card>
                                    <v-card-title>簡訊發送客戶列表</v-card-title>
                                    <v-list style="max-height: 400px" class="overflow-y-auto">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-btn @click="removeAllSelectItem">全不選</v-btn>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>客戶姓名/電話</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-content>
                                                <v-list-item-title>業務員/等級</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <div v-for="(field, index) in holder_selected_list" :key="index">
                                            <v-list-item two-line :class="[{'blue lighten-5': field.selected }, 'white']">
                                                <v-list-item-action>
                                                    <v-btn @click="removeSelectedItem(field.id)">移除</v-btn>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{field.name}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{field.phone}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{field.salesman}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{field.level}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider v-if="index + 1 < holder_selected_list.length"></v-divider>
                                        </div>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </v-card>
</template>
<script>
import SalesmanCombo from '../../components/SalesmanCombo'
import HolderNotifyService from '../../services/HolderNotifyService'
import HolderService from '../../services/HolderService'
export default ({
    components: {
        SalesmanCombo,
    },
    data(){
        return {
            requestItem :{
                message:'',
                holders:[]
            },
            message:'',

            holder_list:[], //欲傳送的客戶資料
            holder_selected_list:[], //簡訊發送客戶列表
            sendDialog: false, //簡訊確認對話框控制
            sendMessageLoading: false,
            isNotSelectHolder: false,
            disableCloseSendButton: false,
            sentMessageResultDialog: false, //簡訊發送完成確認控制
            listHolders:[
                {text: '查看內容',  value:'actions', sortable:false, width: '80px'},
                {text: '客戶姓名',  value:'name', width: '80px'},
                {text: '電話',     value:'phone', width: '60px'},
                {text: '等級',  value:'level', width: '60px'},
                {text: '業務員',   value:'salesman', width: '100px'},
                
            ], //客戶DataTable表頭
            level: '', //保單查詢欄位值
            salesman:null, //保單查詢欄位值
            holderName:'', //客戶姓名
            level_items: ['A','B','C','D'], 
        }
    },
    mounted() {
        this.searchHolders();
    },
    
    setup() {
        
    },
    computed:{
        DisplayedMessage(){
            return this.requestItem.message.replace(/(?:\r\n|\r|\n)/g,'<br/>')
        },
        salesmanName(){
            if (this.salesman===null) return ''
            return this.salesman.name
        },
        levelName(){
            if (this.level===null) return ''
            return this.level
        },
    },
    methods: {
        searchHolders(){
            HolderService.findCanSendSMSData(this.levelName,this.salesmanName,this.holderName,1,1000).then((response)=> {
                if (response.result === true) {
                    this.holder_list = response.list.map(this.mapHolderData)
                } else {
                    this.holder_list = []
                }
            })
        },
        mapHolderData(item){
            return {
                id: item.id,
                name: item.name,
                phone: item.phone,
                level: item.level,
                salesman: (item.salesman_id!=null) ? item.salesman.name : '',
                selected: (this.holder_selected_list.findIndex(element => element.id == item.id) != -1),
                isCellPhone: ((item.phone.search(/^09\d{2}-?\d{3}-?\d{3}$/)) != -1) ? true: false //電話號碼為手機號碼
            }
        },
        removeSelectedItem(holder_id){ //刪除發送列表中指定的客戶
            var idx = this.holder_selected_list.findIndex(element => element.id == holder_id);
            if (idx != -1) {
                this.holder_selected_list.splice(idx, 1);
            }
            var item = this.holder_list.find(element => element.id == holder_id)
            if (item != undefined){
                item.selected = false
            }
        },
        removeAllSelectItem(){ //刪除所有發送列表的客戶
            console.log(this.holder_selected_list.length,'removeAllSelectItem')
            //因為removeSelectedItem會移除陣列元素，會影響這裡的loop，所以先複製到新陣列，以新陣列跑迴圈
            let temp_arr = Array.from(this.holder_selected_list)
            temp_arr.forEach(element => {
                this.removeSelectedItem(element.id)
            });
        },
        addItemToSelectList(holder_id){ //加入客戶到發送列表
            var item = this.holder_list.find(element => element.id == holder_id)
            if (item != undefined){
                if (item.isCellPhone == true) //手機號碼才可以加
                {
                    this.holder_selected_list.push(
                        { 
                            id: item.id,
                            name: item.name,
                            phone: item.phone,
                            salesman: item.salesman,
                            level: item.level
                        }
                    )
                    item.selected = true
                }
                
            }
        },
        addAllItemToSelectList(){ //把所有客戶加入到發送列表
            this.holder_list.forEach(element => {
                if (element.selected == false){
                    this.addItemToSelectList(element.id)
                }
            });
        },
        onSearchClick(){
            this.searchHolders();
        },
        onFindClick(){
            this.$router.push({ name: "holdersmses-list" });
        },
        onSendClick(){
            if (this.$refs.form.validate()){
                if (this.holder_selected_list.length == 0) {
                    this.isNotSelectHolder = true
                } else {
                    this.isNotSelectHolder = false
                    this.sendDialog = true
                }
            } 
        },
        closeSendDialog(){
            this.sendMessageLoading = false
            this.sendDialog = false
        },
        confirmSendMessage(){
            this.requestItem.holders = []
            this.holder_selected_list.forEach(element => {
                this.requestItem.holders.push(element.id)
            });
            console.log(this.requestItem, 'confirmSendMessage')
            //呼叫API，執行簡訊發送
            this.sendMessageLoading = true
            this.disableCloseSendButton = true   
            HolderNotifyService.sendSMSToHolder(this.requestItem.message, this.requestItem.holders)
                .then((response) => {
                    //發送完成，顯示結果對話框
                    this.message = response.message;
                    this.removeAllSelectItem();
                    this.requestItem.message ='';
                })
                .catch((e) => {
                    console.log(e, 'NewMessage.vue.confirmSendMessage')
                    this.message = '發送出現錯誤' + e.message
                })
            this.sentMessageResultDialog = true
        },
        confirmSentResult(){
            this.message = ''
            //停止傳送loading 及 取消傳送按鍵凍結
            this.sendMessageLoading = false
            this.disableCloseSendButton = false   
            //關閉結果對話框
            this.sentMessageResultDialog = false
            //關閉確認對話框
            this.sendDialog = false
        }
    },
})
</script>
